type TRuleFactoryParams = Record<string, any>;

export interface GenericRule<T> {
  validateOrThrow(entity: T): void;
}

export interface GenericRuleFactory<T> {
  create(params: TRuleFactoryParams): GenericRule<T>[];
}

export class GenericValidator<T, RuleFactoryParams extends TRuleFactoryParams> {
  constructor(private readonly genericRulesFactory: GenericRuleFactory<T>) {}

  validateOrThrow(entity: T, ruleFactoryParams: RuleFactoryParams): void {
    const rules = this.genericRulesFactory.create(ruleFactoryParams);

    rules.forEach((rule) => rule.validateOrThrow(entity));
  }
}
